import { useRole } from '@ztechapps/common.hook'
import { chatPermissions } from '@ztechapps/chat.common'
import { orderPermissions } from '@ztechapps/order.common'

export const orderFromConversationDeniedTitle = 'You do not have permission to create an order from a conversation'

export type UseCanCreateOrderFromConversationResult = { canCreateOrderFromConversation: boolean }

export const useCanCreateOrderFromConversation = (): UseCanCreateOrderFromConversationResult => {
  const { hasRole: canEditOrder } = useRole({ roleName: orderPermissions.canEdit.value })
  const { hasRole: canEditChat } = useRole({ roleName: chatPermissions.canEdit.value })
  return { canCreateOrderFromConversation: canEditOrder && canEditChat }
}
